import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.game');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";
import { TTS } from "src/libs/portal/korslovo/tts";

type GamePhase = 'mode_select' | 'select' | 'playing' | 'bonus' | 'result' | 'crossword_mode';

interface PuzzleWord {
    word_id: string;
    korean: string;
    russian: string;
    row: number;
    col: number;
    direction: string;
    length: number;
    is_bonus: boolean;
    found: boolean;
    colorIndex: number;
}

interface Cell {
    char: string;
    row: number;
    col: number;
}

interface GameResult {
    xp_earned: number;
    total_xp: number;
    old_level: number;
    new_level: number;
    level_up: boolean;
    star_info: any;
    next_star: any;
    game_plays: number;
    lesson_hint: { show: boolean; repeat_pct: number; message_key: string } | null;
}

const FOUND_COLORS = [
    'bg-emerald-200', 'bg-blue-200', 'bg-amber-200', 'bg-rose-200',
    'bg-purple-200', 'bg-cyan-200', 'bg-orange-200', 'bg-teal-200'
];

@Component({
    selector: 'wiz-page-korslovo-game',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.game/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

/* Prevent iOS Safari from intercepting touch events as scroll/zoom on the game grid */
.ws-grid {
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-4px);
  }
  40% {
    transform: translateX(4px);
  }
  60% {
    transform: translateX(-3px);
  }
  80% {
    transform: translateX(3px);
  }
}
.animate-shake {
  animation: shake 0.4s ease-in-out;
}

/* ═══ XP Earned Badge ═══ */
.xp-earned-badge {
  animation: xpBadgeIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes xpBadgeIn {
  0% {
    transform: scale(0) rotate(-20deg);
    opacity: 0;
  }
  60% {
    transform: scale(1.15) rotate(5deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
.xp-counter {
  font-variant-numeric: tabular-nums;
}

/* ═══ Star Result Badge ═══ */
.star-result-badge {
  animation: starBadgePop 0.5s 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes starBadgePop {
  0% {
    transform: scale(0) rotate(-180deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}
/* ═══ Level Up Modal ═══ */
.level-up-overlay {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.level-up-card {
  animation: cardSlideUp 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes cardSlideUp {
  0% {
    transform: translateY(40px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.level-up-icon {
  animation: levelUpStar 1.5s ease-in-out infinite;
  filter: drop-shadow(0 0 12px rgba(251, 191, 36, 0.5));
}

@keyframes levelUpStar {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.15) rotate(-10deg);
  }
  50% {
    transform: scale(1.25) rotate(0deg);
  }
  75% {
    transform: scale(1.15) rotate(10deg);
  }
}
/* ═══ Confetti Stars ═══ */
.confetti-star {
  position: absolute;
  font-size: 16px;
  opacity: 0;
  animation: confettiFall 2s ease-in infinite;
}

.cs-1 {
  left: 10%;
  color: #f59e0b;
  animation-delay: 0s;
  font-size: 14px;
}

.cs-2 {
  left: 25%;
  color: #8b5cf6;
  animation-delay: 0.3s;
  font-size: 18px;
}

.cs-3 {
  left: 45%;
  color: #10b981;
  animation-delay: 0.6s;
  font-size: 12px;
}

.cs-4 {
  left: 60%;
  color: #ef4444;
  animation-delay: 0.9s;
  font-size: 16px;
}

.cs-5 {
  left: 75%;
  color: #3b82f6;
  animation-delay: 1.2s;
  font-size: 10px;
}

.cs-6 {
  left: 90%;
  color: #f59e0b;
  animation-delay: 1.5s;
  font-size: 14px;
}

.cs-7 {
  left: 35%;
  color: #ec4899;
  animation-delay: 0.4s;
  font-size: 12px;
}

.cs-8 {
  left: 80%;
  color: #06b6d4;
  animation-delay: 0.8s;
  font-size: 16px;
}

@keyframes confettiFall {
  0% {
    top: -10%;
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: rotate(180deg) scale(1.2);
  }
  100% {
    top: 100%;
    opacity: 0;
    transform: rotate(360deg) scale(0.5);
  }
}`],
})
export class PageKorslovoGameComponent implements OnInit, OnDestroy {
    public ru = RU;
    public phase: GamePhase = 'mode_select';
    public loading: boolean = true;
    public totalLearned: number = 0;

    // Difficulty
    public difficulty: string = 'easy';

    // Grid
    public grid: string[][] = [];
    public gridSize: number = 10;
    public words: PuzzleWord[] = [];
    public bonusWords: PuzzleWord[] = [];

    // Selection state
    public selecting: boolean = false;
    public selectedCells: { row: number; col: number }[] = [];
    public startCell: { row: number; col: number } | null = null;

    // XP / Star Result
    public gameResult: GameResult | null = null;
    public showXpAnimation: boolean = false;
    public showLevelUp: boolean = false;
    public xpAnimValue: number = 0;

    // Game state
    public foundCount: number = 0;
    public totalWords: number = 0;
    public wrongTries: number = 0;
    public timerSeconds: number = 0;
    public cellColors: Map<string, string> = new Map();
    public colorIndex: number = 0;
    public shaking: boolean = false;

    // Bonus
    public bonusFoundCount: number = 0;
    public _bonusHintCells: Set<string> = new Set();

    // Result
    public bestTime: number = 0;

    // Word IDs for history tracking
    private puzzleWordIds: string[] = [];

    // Crossword lesson picker
    public crosswordCategories: any[] = [];
    public crosswordLoading: boolean = false;

    private timerInterval: any = null;
    private tts: TTS = new TTS();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadWordCount();
    }

    ngOnDestroy() {
        this.stopTimer();
        this.tts.stop();
    }

    // ─── Phase: Mode Select ───
    public async loadWordCount() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("words");
        if (code === 200) {
            this.totalLearned = data.total_learned || 0;
        }
        this.loading = false;
        await this.service.render();
    }

    public selectWordSearch() {
        this.phase = 'select';
        this.service.render();
    }

    public async selectCrossword() {
        this.phase = 'crossword_mode';
        await this.service.render();
    }

    public async selectCrosswordMode(mode: string) {
        this.service.href(`/crossword/random?mode=${mode}`);
    }

    public goCrossword(lessonId: string) {
        this.service.href(`/crossword/${lessonId}`);
    }

    public backToModeSelect() {
        this.phase = 'mode_select';
        this.service.render();
    }

    // ─── Phase: Select (Word Search) ───
    public canPlay(diff: string): boolean {
        const needed: any = { easy: 8, normal: 12, hard: 15 };
        return this.totalLearned >= (needed[diff] || 8);
    }

    public async startGame(diff: string) {
        if (!this.canPlay(diff)) return;
        this.difficulty = diff;
        this.loading = true;
        this.phase = 'playing';
        await this.service.render();

        const { code, data } = await wiz.call("generate_puzzle", { difficulty: diff });
        if (code === 200 && !data.error) {
            this.grid = data.grid;
            this.gridSize = data.grid_size;
            this.words = (data.words || []).map((w: any, i: number) => ({ ...w, found: false, colorIndex: i }));
            this.bonusWords = (data.bonus_words || []).map((w: any, i: number) => ({ ...w, found: false, colorIndex: this.words.length + i }));
            this.totalWords = this.words.length;
            this.foundCount = 0;
            this.wrongTries = 0;
            this.timerSeconds = 0;
            this.cellColors = new Map();
            this.colorIndex = 0;
            this.selectedCells = [];
            this.selecting = false;
            this.startCell = null;
            this.bonusFoundCount = 0;
            // Collect word IDs for history tracking
            const wordIdSet = new Set<string>();
            for (const w of this.words) { if (w.word_id) wordIdSet.add(w.word_id); }
            for (const w of this.bonusWords) { if (w.word_id) wordIdSet.add(w.word_id); }
            this.puzzleWordIds = Array.from(wordIdSet);
            this.updateBonusHintCells();
            this.loadBestTime();
            this.startTimer();
        } else {
            this.phase = 'select';
        }
        this.loading = false;
        await this.service.render();
    }

    // ─── Timer ───
    private startTimer() {
        this.stopTimer();
        this.timerInterval = setInterval(() => {
            this.timerSeconds++;
            this.service.render();
        }, 1000);
    }

    private stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    }

    public formatTime(s: number): string {
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    }

    // ─── Cell size ───
    public get cellSize(): number {
        const maxWidth = Math.min(window.innerWidth - 32, 480);
        return Math.floor(maxWidth / this.gridSize);
    }

    // ─── Selection ───
    public cellKey(r: number, c: number): string {
        return `${r},${c}`;
    }

    public isCellSelected(r: number, c: number): boolean {
        return this.selectedCells.some(s => s.row === r && s.col === c);
    }

    public getCellBg(r: number, c: number): string {
        const key = this.cellKey(r, c);
        if (this.cellColors.has(key)) return this.cellColors.get(key)!;
        if (this.isCellSelected(r, c)) return 'bg-emerald-100';
        return '';
    }

    public onCellPointerDown(r: number, c: number, event: any) {
        event.preventDefault();
        this.selecting = true;
        this.startCell = { row: r, col: c };
        this.selectedCells = [{ row: r, col: c }];
        this.service.render();
    }

    public onCellPointerMove(r: number, c: number, event: any) {
        if (!this.selecting || !this.startCell) return;
        event.preventDefault();
        this.updateSelection(r, c);
        this.service.render();
    }

    public onCellPointerUp(event: any) {
        if (!this.selecting) return;
        event.preventDefault();
        this.selecting = false;
        this.checkSelection();
    }

    // Touch events on grid container
    public onTouchMove(event: TouchEvent) {
        if (!this.selecting) return;
        event.preventDefault();
        const touch = event.touches[0];
        const el = document.elementFromPoint(touch.clientX, touch.clientY);
        if (el) {
            const rowAttr = el.getAttribute('data-row');
            const colAttr = el.getAttribute('data-col');
            if (rowAttr !== null && colAttr !== null) {
                this.updateSelection(parseInt(rowAttr), parseInt(colAttr));
                this.service.render();
            }
        }
    }

    public onTouchEnd(event: TouchEvent) {
        if (!this.selecting) return;
        this.selecting = false;
        this.checkSelection();
    }

    private updateSelection(endRow: number, endCol: number) {
        if (!this.startCell) return;
        const sr = this.startCell.row;
        const sc = this.startCell.col;
        const dr = Math.sign(endRow - sr);
        const dc = Math.sign(endCol - sc);

        // 직선 방향만 허용 (가로, 세로, 대각선)
        const diffR = Math.abs(endRow - sr);
        const diffC = Math.abs(endCol - sc);
        if (diffR !== 0 && diffC !== 0 && diffR !== diffC) return;

        const cells: { row: number; col: number }[] = [];
        const steps = Math.max(diffR, diffC);
        for (let i = 0; i <= steps; i++) {
            cells.push({ row: sr + dr * i, col: sc + dc * i });
        }
        this.selectedCells = cells;
    }

    private async checkSelection() {
        if (this.selectedCells.length < 1) return;

        const selectedStr = this.selectedCells.map(c => this.grid[c.row][c.col]).join('');
        const reversedStr = [...selectedStr].reverse().join('');

        // 현재 활성 단어 목록 (phase에 따라)
        const activeWords = this.phase === 'bonus' ? this.bonusWords : this.words;
        let matched: PuzzleWord | null = null;

        for (const w of activeWords) {
            if (w.found) continue;
            if (w.korean === selectedStr || w.korean === reversedStr) {
                matched = w;
                break;
            }
        }

        if (matched) {
            matched.found = true;
            const color = FOUND_COLORS[this.colorIndex % FOUND_COLORS.length];
            this.colorIndex++;

            // 정답 셀에 색상 지정
            const syllables = matched.korean.split('');
            const [dr, dc] = matched.direction.split(',').map(Number);
            for (let i = 0; i < syllables.length; i++) {
                const key = this.cellKey(matched.row + dr * i, matched.col + dc * i);
                this.cellColors.set(key, color);
            }

            if (this.phase === 'bonus') {
                this.bonusFoundCount++;
                this.updateBonusHintCells();
                this.tts.speak(matched.korean);
            } else {
                this.foundCount++;
                if (this.foundCount >= this.totalWords) {
                    this.stopTimer();
                    this.saveBestTime();
                    // 보너스 라운드 전환 또는 결과
                    if (this.bonusWords.length > 0 && this.bonusWords.some(bw => !bw.found)) {
                        this.phase = 'bonus';
                        this.updateBonusHintCells();
                    } else {
                        await this.goToResult();
                    }
                }
            }
        } else if (this.selectedCells.length >= 2) {
            this.wrongTries++;
            this.shaking = true;
            setTimeout(async () => {
                this.shaking = false;
                await this.service.render();
            }, 400);
        }

        this.selectedCells = [];
        this.startCell = null;
        await this.service.render();
    }

    // ─── Bonus ───
    public get activeBonusWords(): PuzzleWord[] {
        return this.bonusWords.filter(w => !w.found);
    }

    private updateBonusHintCells() {
        this._bonusHintCells = new Set<string>();
        for (const w of this.bonusWords) {
            if (!w.found) {
                this._bonusHintCells.add(this.cellKey(w.row, w.col));
            }
        }
    }

    public bonusHintCells(): Set<string> {
        return this._bonusHintCells;
    }

    public async skipBonus() {
        await this.goToResult();
    }

    public async finishBonus() {
        await this.goToResult();
    }

    // ─── Result ───
    private async goToResult() {
        this.phase = 'result';
        await this.service.render();
        await this.saveGameResult();
    }

    private async saveGameResult() {
        try {
            const { code, data } = await wiz.call("save_result", {
                game_type: "word_search",
                difficulty: this.difficulty,
                words_found: this.foundCount,
                total_words: this.totalWords,
                bonus_found: this.bonusFoundCount,
                wrong_tries: this.wrongTries,
                time_seconds: this.timerSeconds,
                word_ids: JSON.stringify(this.puzzleWordIds)
            });
            if (code === 200 && data) {
                this.gameResult = data;
                // XP animation
                this.showXpAnimation = true;
                this.xpAnimValue = 0;
                await this.service.render();
                await this.animateXp(data.xp_earned);
                // Level up animation
                if (data.level_up) {
                    this.showLevelUp = true;
                    await this.service.render();
                }
            }
        } catch (e) {
            // 저장 실패해도 결과는 표시
        }
    }

    private async animateXp(target: number) {
        const duration = 1200;
        const steps = 30;
        const increment = target / steps;
        const stepTime = duration / steps;
        for (let i = 1; i <= steps; i++) {
            this.xpAnimValue = Math.min(Math.round(increment * i), target);
            await this.service.render();
            await new Promise(r => setTimeout(r, stepTime));
        }
        this.xpAnimValue = target;
        await this.service.render();
    }

    public dismissLevelUp() {
        this.showLevelUp = false;
        this.service.render();
    }

    public async retryGame() {
        await this.startGame(this.difficulty);
    }

    public async newGame() {
        this.phase = 'mode_select';
        this.stopTimer();
        await this.service.render();
    }

    public goHome() {
        this.service.href('/dashboard');
    }

    // ─── Best time (localStorage) ───
    private storageKey(): string {
        return `korslovo_game_best_${this.difficulty}`;
    }

    private loadBestTime() {
        const val = localStorage.getItem(this.storageKey());
        this.bestTime = val ? parseInt(val) : 0;
    }

    private saveBestTime() {
        if (this.bestTime === 0 || this.timerSeconds < this.bestTime) {
            this.bestTime = this.timerSeconds;
            localStorage.setItem(this.storageKey(), String(this.timerSeconds));
        }
    }
}

export default PageKorslovoGameComponent;